import { createContext } from 'react';
import { UseQueryResult } from '@tanstack/react-query';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const GenericDataContext = createContext<UseQueryResult<any>>({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as UseQueryResult<any>);

export default GenericDataContext;
